/* eslint-disable import/order */
import { globalAdminPrioritiesEntryPoint } from '@jira/admin-pages__priorities/src/globalAdminPrioritiesEntryPoint.entrypoint.tsx';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsIssuesPrioritiesRoute } from '@jira/router-routes__admin-pages-priorities-routes/src/globalSettingsIssuesPrioritiesRoute.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import PrioritiesPage, {
	LazyPrioritiesPage,
} from './ui/spa/admin-pages/priorities/issue-priorities/index.tsx';

const globalSettingsIssuesPrioritiesRouteEntryPointPage = createPageEntryPoint({
	main: globalAdminPrioritiesEntryPoint,
});

export const globalSettingsIssuesPrioritiesRouteEntry: Route = createEntry(
	globalSettingsIssuesPrioritiesRoute,
	() => ({
		group: 'global-settings',
		// eslint-disable-next-line no-restricted-syntax
		component: PrioritiesPage,
		layout: globalSettingsLayout,

		entryPoint: () =>
			fg('eax-1638_priorities_page_route_to_use_entrypoint')
				? globalSettingsIssuesPrioritiesRouteEntryPointPage
				: undefined,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyPrioritiesPage],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
